// usePermissionChecker.ts
import { useSelector, shallowEqual } from 'react-redux';
import { RootState } from '../../setup';
import { IAccount } from '../modules/auth/models/AccountModel';
import { IPermission } from '../modules/auth/models/PermissionsModel';
import { SALES_ROLE } from '../constants/role';
import { BUSINESS_TYPE_COMPANY, DECIMALS } from '../constants/common';
export const usePermissionChecker = () => {
  const user: IAccount = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as IAccount;
  const role = user?.roles as any;
  const permissions: IPermission[] = (role && role.length > 0) ? role[0].permissions as IPermission[] : [];
  const hasPermission = (permissionName: string): boolean => {
    if (IsSentoAdmin()) {
      return true;
    }

    if (!Array.isArray(permissions)) {
      return false;
    }

    for (const modelPermissions of permissions) {
      if (modelPermissions?.name === permissionName) {
        return true;
      }
    }

    return false;
  };

  return { hasPermission };
};

export const Sento = () => {
  const user: IAccount = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as IAccount;
  return user.is_super_admin === 1
}

export const IsSentoAdmin = () => {
  const user: IAccount = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as IAccount;
  return user.is_super_admin === 1
}

export const UserLoggedIn = () => {
  const user: IAccount = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as IAccount;
  return user;
}

export const IsSales = () => {
  const user: IAccount = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as IAccount;
  return user?.is_sales == 1;
}

export const IsCashier = () => {
  const user: IAccount = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as IAccount;
  return user?.is_cashier == 1;
}

export const IsCompany = () => {
  const user: IAccount = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as IAccount;
  return user?.store?.is_company === BUSINESS_TYPE_COMPANY;
}

export const GetStoreIfo = () => {
  const user: IAccount = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as IAccount;
  return user?.store;
}

export const GetStoreConfig = () => {
  const user: IAccount = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as IAccount;
  return user?.store?.open_store_config;
}

export const ConfigDecimals = () => {
  const user: IAccount = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as IAccount;
  return DECIMALS[user?.store?.open_store_config?.number_format ?? 'default'] ?? 0;
}